import React, { Component } from 'react';
import CommonRegistrationView from './CommonRegistrationView';
import { CommonRegistrationApi } from '../Api';

class CommonRegistrationComponent extends Component {
  state = {
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    // confirmpassword: '',
    matchalert: '',
    email_validation: '',
    setpassword_validate: '',
    setfirstname_validate: '',
    setlastname_validate: '',
    confirmemail: '',
    email_match: '',
    custom_model: false,
    strong_text: '',
    h5_text: '',
    h1_text: '',
    employeer: false,
    visible_password: false,
  };
  state = {
    authResponse: '',
    modal_show: false,
  };

  hideCustomModal = () => {
    this.setState({ modal_show: false });
    if (
      this.state.strong_text ==
      'Thanks for completing step 1 in the registration process.'
    ) {
      window.location.replace('/home');
    }
  };

  showCustomModal = () => {
    this.setState({ modal_show: true });
  };
  show_password = (e) => {
    if (e.target.checked) {
      this.setState({ visible_password: true });
    } else {
      this.setState({ visible_password: false });
    }
  };

  handelData = (identity, data) => {
    if (identity === 'first_name') {
      console.log('data', data);

      if (/^([a-zA-Z]+[,.]?[ ]?|[a-zA-Z]+['-]?)+$/.test(data)) {
        this.setState({ first_name: data });
        this.setState({ setfirstname_validate: '' });
      } else if (data.length <= 0) {
        this.setState({ setfirstname_validate: '' });
      } else {
        this.setState({
          setfirstname_validate: 'Please Enter a valid firstname',
        });
      }
    }
    if (identity === 'last_name') {
      if (/^([a-zA-Z]+[,.]?[ ]?|[a-zA-Z]+['-]?)+$/.test(data)) {
        this.setState({ last_name: data });
        this.setState({ setlastname_validate: '' });
      } else if (data.length <= 0) {
        this.setState({ setlastname_validate: '' });
      } else {
        this.setState({
          setlastname_validate: 'Please Enter a valid lastname',
        });
      }
    }
    if (identity === 'email') {
      this.setState({ email: data });
      console.log('email', data);
    }
    if (identity === 'password') {
      if (data.length <= 7) {
        this.setState({
          setpassword_validate:
            'Password must contain at least 8 characters, including UPPER/lowercase',
        });
      } else if (!/(?=.*[A-Z])/.test(data)) {
        this.setState({
          setpassword_validate:
            'Password must contain at least 8 characters, including UPPER/lowercase',
        });
      } else if (!/(?=.*[a-z])/.test(data)) {
        this.setState({
          setpassword_validate:
            'Password must contain at least 8 characters, including UPPER/lowercase',
        });
      } else if (!/(?=.*[0-9])/.test(data)) {
        this.setState({ setpassword_validate: 'Contain at least one number' });
      } else {
        this.setState({ password: data });
        this.setState({ setpassword_validate: '' });
      }
      console.log('data', data);
    }
    // if (identity === 'confirmpassword') {
    //   console.log('data', data)
    //   this.setState({ confirmpassword: data })
    // }
    if (identity === 'confirmemail') {
      console.log('confirmemail', data);
      this.setState({ confirmemail: data });
    }
  };
  handelSummit = async () => {
    console.log('this.state.confirmemail', this.state.confirmemail);
    console.log('this.state.email', this.state.email);
    if (
      this.state.setpassword_validate === '' &&
      this.state.setlastname_validate === '' &&
      this.state.setfirstname_validate === ''
    ) {
      if (this.state.email === this.state.confirmemail) {
        // if (this.state.password === this.state.confirmpassword) {

        if (this.state.employeer) {
          var data = {
            first_name: this.state.first_name,
            last_name: this.state.last_name,
            email: this.state.email,
            password: this.state.password,
            is_client: true,
            is_applicant: false,
          };
        } else {
          var data = {
            first_name: this.state.first_name,
            last_name: this.state.last_name,
            email: this.state.email,
            password: this.state.password,
            is_applicant: true,
            is_client: false,
          };
        }
        var responce = await CommonRegistrationApi(data, this);
        console.log('responce-api', responce);
        // }
        // else {
        //   this.setState({ matchalert: 'password does not match' })
        // }
      } else {
        this.setState({ email_match: 'email does not match' });
      }
    } else {
      this.showCustomModal();
      this.setState({
        authResponse: 'Please make sure all details are correct',
      });
    }
  };
  componentDidMount() {
    const uri = window.location.href.split('/').pop();
    if (uri === '#employer') {
      this.setState({ employeer: true });
    }
    localStorage.removeItem('is_post_job');
  }
  render() {
    return (
      <CommonRegistrationView
        email_match={this.state.email_match}
        setlastname_validate={this.state.setlastname_validate}
        setfirstname_validate={this.state.setfirstname_validate}
        setpassword_validate={this.state.setpassword_validate}
        email_validation={this.state.email_validation}
        matchalert={this.state.matchalert}
        handelData={this.handelData}
        handelSummit={this.handelSummit}
        authResponse={this.state.authResponse}
        modal_show={this.state.modal_show}
        hideCustomModal={this.hideCustomModal}
        custom_model={this.state.custom_model}
        strong_text={this.state.strong_text}
        h1_text={this.state.h1_text}
        h5_text={this.state.h5_text}
        visible_password={this.state.visible_password}
        show_password={this.show_password}
      />
    );
  }
}

export default CommonRegistrationComponent;
